function zipCodeValidator({ input, locale, msgs }) {
  const isLocaleFr = ['fr', 'fr-BE', 'fr-CA', 'fr-CH', 'fr-FR', 'fr-LU', 'fr-MC'].includes(locale);
  let rule = /^\d{5}((-| |)\d{4})?$/;

  if (isLocaleFr) {
    rule = /^[a-zA-Z0-9\- ]+$/;
  }

  if (!rule.test(input)) {
    return msgs.msg || 'Please enter either a 5 or a 9 digit zip code.';
  }

  return null;
}

export default zipCodeValidator;
